export default __webpack_public_path__ + "static/media/MemberTabActive.7773d46a.svg";